/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AgentGetCardRequest} from '@cash-web/protos/squareup/cash/agentcore/api/v1beta1/agent_card_messages.pb'
import {AgentGetCardResponse} from '@cash-web/protos/squareup/cash/agentcore/api/v1beta1/agent_card_messages.pb'


export const agentGetCard = (request: AgentGetCardRequest, options?: CashRequestOptions) => post<AgentGetCardRequest, AgentGetCardResponse>("/2.0/cash/agent-get-card", request, {...options, rejectOnError: true })